import { Login } from '@/services/api/ApiRoutes';

export default class User {
  static loggedIn() {
    return localStorage.getItem('user');
  }

  static async login(login) {
    try {
      const response = await Login.login(login);
      console.log("Got response", response);

      localStorage.setItem('user', JSON.stringify(response.user));
      localStorage.setItem('token', response.token);

      return true;
    } catch (error) {
      throw new Error(error.message);
    }

    //return localStorage.setItem('user', 'testToken');
  }

  static async logout() {
    return localStorage.removeItem('user');
  }

  static get() {
    return JSON.parse(localStorage.getItem('user'));
    //return ApiUsers.getCurrent();
  }
}



// WEBPACK FOOTER //
// ./src/services/api/User.js